import { instance } from "../libs/client";

class JobService {
  createJob = async (data) => {
    return instance.post(`job/`, data);
  };
  getJobs = async () => {
    return instance.get(`job/`);
  };
  getJobsPaginated = async (pageNo = 1, search = "", take = 5, status = 'all') => {
    return instance.get(`job/${status}/paginated?page=${pageNo}${search ? `&search=${search}` : ""}${take ? `&take=${take}` : 5}`);
  };
  updateJob = async (id, data) => {
    return instance.put(`job/${id}`, data);
  };
  getJSON = async (id, data) => {
    return instance.get(`job/${id}`);
  };
  deleteJob = async (id) => {
    return instance.delete(`job/${id}`);
  };
  requestTally = async (data) => {
    return instance.post(`job/request-tally`, data);
  };
  getExcelFile = async (data) => {
    return instance.post(`job/get-excel-file`, data, {
      responseType: 'blob'
    });
  };
}
const jobService = new JobService();
export { jobService };
